$(document).ready(function(){

    var form = $('#userForm');

    initSuppressionUserListener(rootUrl);
    initUserFormValidate(form);
});

function initSuppressionUserListener(rootUrl){
    $('#btn-supprimer-user').click(function(){
        var verif = confirm("Voulez-vous vraiment supprimer cet utilisateur ?");
        if(verif){
            var utilisateurId = $('#idUtilisateur').val();
            $.ajax({
                type:'GET',
                url: rootUrl+'user/supprimerUser',
                data: { utilisateurId: utilisateurId },
                async: true,
                dataType: 'text',
                contentType: 'application/x-www-form-urlencoded;charset=UTF-8',
                beforeSend:function(xhr){
                    xhr.overrideMimeType('text/html;charset=UTF-8');
                },
                success:function(data, textStatus){
                    document.location.href=rootUrl+'user';
                },
                error:function(xhr, textStatus, thrownError){
                    alert('Erreur AJAX : '+thrownError);
                }
            });
        }
    });
}

function initUserFormValidate(form){

    $.extend($.validator.messages, {
        required: "Veuillez renseigner ce champ",
        email: "Veuillez saisir un email valide",
        equalTo: "La confirmation est différente du nouveau mot de passe, veuillez la saisir à nouveau"
    });

    form.validate({
        onkeyup: false,
        onfocusout: false,
        errorElement: "div",
        errorPlacement: function (error, element) {
            error.insertAfter(element);
        },
        rules: {
            "loginUtilisateur": {
                required: true
            },
            "emailUtilisateur": {
                required: true
            },
            "newPwd":{
                required: function(element) {
                    return ($('#previousPwd').val() !== "");
                }
            },
            "newPwdConfirm": {
                equalTo: "#newPwd"
            },
            "roleUtilisateur": {
                required: true
            }
        }
    });
}
